"use client";

import { Button } from "@/component/override/button.c";
import { useLanguage } from "@/context/language-context";
import { getLocalizedPath } from "@/lib/routes";
import { cn } from "@/lib/utils";
import { usePathname, useRouter } from "next/navigation";

interface LanguageSwitcherProps {
  className?: string;
}

export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { language, setLanguage } = useLanguage();
  const pathname = usePathname();
  const router = useRouter();

  const handleLanguageChange = (newLanguage: 'en' | 'it') => {
    if (newLanguage === language) return;

    setLanguage(newLanguage);
    const newPath = getLocalizedPath(pathname, newLanguage);
    router.push(newPath);
  };

  return (
    <div className={cn("flex items-center gap-1", className)}>
      <Button
        size="sm"
        variant={language === "it" ? "solid" : "light"}
        color="primary"
        onPress={() => handleLanguageChange("it")}
        className="min-w-0 px-2"
      >
        🇮🇹
      </Button>
      <span className="text-default-400">|</span>
      <Button
        size="sm"
        variant={language === "en" ? "solid" : "light"}
        color="primary"
        onPress={() => handleLanguageChange("en")}
        className="min-w-0 px-2"
      >
        🇬🇧
      </Button>
    </div>
  );
}